module.exports = __webpack_public_path__ + "img/已选@2x.93c9d443.png";